export default {
  default: () => import("/srv/portal/layouts/default.vue").then(m => m.default || m),
  "digital-order": () => import("/srv/portal/layouts/digital-order.vue").then(m => m.default || m),
  "minimal-w-full-footer": () => import("/srv/portal/layouts/minimal-w-full-footer.vue").then(m => m.default || m),
  minimal: () => import("/srv/portal/layouts/minimal.vue").then(m => m.default || m),
  "moto-layout": () => import("/srv/portal/layouts/moto-layout.vue").then(m => m.default || m),
  plain: () => import("/srv/portal/layouts/plain.vue").then(m => m.default || m),
  "press-layout": () => import("/srv/portal/layouts/press-layout.vue").then(m => m.default || m),
  "regulations-layout": () => import("/srv/portal/layouts/regulations-layout.vue").then(m => m.default || m)
}